import * as React from 'react';

import enUS from '../i18n/en-US.json';
import esES from '../i18n/es-ES.json';
import frFR from '../i18n/fr-FR.json';
import itIT from '../i18n/it-IT.json';
import zhHans from '../i18n/zh-Hans.json';

const I18nContext = React.createContext(enUS);
export interface I18nProviderProps {
    locale?: 'en-US' | 'es-ES' | 'fr-FR' | 'it-IT' | 'zh-Hans' | 'en-XB';
}

const mappers: Record<I18nProviderProps['locale'], any> = {
    'en-US': enUS,
    'es-ES': esES,
    'fr-FR': frFR,
    'it-IT': itIT,
    'zh-Hans': zhHans,
    'en-XB': enUS,
};

export const I18nProvider: React.FC<I18nProviderProps> = (props) => {
    const { children, locale } = props;

    const messages = React.useMemo(() => mappers[locale], [locale]);

    return <I18nContext.Provider value={messages}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
    return React.useContext(I18nContext);
};
